export enum CookieConstants {
  SET_COOKIE = 'cookie/SET_COOKIE',
  ON_SET_COOKIE = 'cookie/ON_SET_COOKIE',
}
